import React, { useState } from "react";
import "./FollowupSuggestions.scss";
import { FiChevronDown, FiChevronUp, FiX, FiCornerDownRight } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { clearFollowupSuggestions } from "../../state/actions";

const FollowupSuggestions = ({ suggestions, onSuggestionClick, onClose }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const dispatch = useDispatch();

  if (!Array.isArray(suggestions) || suggestions.length === 0) return null;

  // `onClose` lets the owner remember the dismissal: the chips can be rebuilt
  // from the reply's own text, so clearing the store alone would bring them back.
  const handleClose = () => {
    dispatch(clearFollowupSuggestions());
    onClose?.();
  };

  return (
    <div className="followup-suggestions-wrapper">
      <div
        className="followup-suggestions-header"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <div className="followup-suggestions-title">
          <span className="followup-suggestions-icon">
            <FiCornerDownRight />
          </span>
          Suggested follow-ups
        </div>
        <div className="followup-suggestions-actions">
          <button
            type="button"
            className="followup-icon-button"
            onClick={(e) => {
              e.stopPropagation();
              setIsCollapsed(!isCollapsed);
            }}
            aria-label={isCollapsed ? "Expand suggestions" : "Collapse suggestions"}
          >
            {isCollapsed ? <FiChevronUp /> : <FiChevronDown />}
          </button>
          <button
            type="button"
            className="followup-icon-button"
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
            aria-label="Close suggestions"
          >
            <FiX />
          </button>
        </div>
      </div>
      {!isCollapsed && (
        <div className="followup-suggestions-content">
          <div className="followup-suggestions" aria-label="Follow-up suggestions">
            {suggestions.map((text, idx) => (
              <button
                key={`${idx}-${text}`}
                type="button"
                className="followup-suggestions__chip"
                onClick={() => onSuggestionClick && onSuggestionClick(text)}
              >
                <span className="followup-suggestions__label">{text}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FollowupSuggestions;

